import Link from 'next/link';
import {cn} from '@/lib/utils';
export function Brand({className,link=true}:{className?:string;link?:boolean}){
 const body=<><span className="grid size-8.5 place-items-center rounded-[11px] bg-sidebar-primary font-heading text-xl font-bold text-sidebar-primary-foreground">F</span> finnie</>;
 const cls=cn('flex items-center gap-2.5 font-heading text-[29px] tracking-[-0.04em] text-sidebar-foreground',className);
 return link?<Link href="/" className={cls}>{body}</Link>:<div className={cls}>{body}</div>;
}
